import axios from "axios";
import { Notification } from "element-ui";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 1200000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      config.headers['Authorization'] = localStorage.getItem("token") // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers["Content-Type"] = config.type
      ? "application/x-www-form-urlencoded"
      : "application/json";
    return config;
  },
  (error) => {
    // 如果是取消请求的错误，直接返回，不显示错误提示
    if (axios.isCancel(error)) {
      console.log("请求取消", error.message);
      return Promise.reject(error);
    }
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    let code = response.status;

    if (code != 200) {
      Notification.error({
        title: response.message || "操作222失败",
      });
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  (error) => {
    // 如果是取消请求的错误，直接返回，不显示错误提示
    if (axios.isCancel(error)) {
      console.log("请求取消", error.message);
      return Promise.reject(error);
    }

    // 原有的错误处理
    if (typeof code !== "undefined") {
    } else {
      Notification.error({
        title: "接口请求失败",
        duration: 5000,
      });
    }
    return Promise.reject(error);
  }
);
export default service;
